import { Viewports } from "../store/enums";
import { setViewport } from "../store/actions";

export const initViewportListener = (store) => {
  const computedStyle = getComputedStyle(document.documentElement);

  const tablet = computedStyle.getPropertyValue("--sd-tablet");
  const laptop = computedStyle.getPropertyValue("--sd-laptop");
  const desktop = computedStyle.getPropertyValue("--sd-desktop");

  const tabletQuery = window.matchMedia(`(min-width: ${tablet})`);
  const laptopQuery = window.matchMedia(`(min-width: ${laptop})`);
  const desktopQuery = window.matchMedia(`(min-width: ${desktop})`);

  const handleTabletViewportChange = ({ matches }) => {
    if (matches) {
      store.dispatch(setViewport(Viewports.Tablet));
    } else {
      store.dispatch(setViewport(Viewports.Mobile));
    }
  };

  const handleLaptopViewportChange = ({ matches }) => {
    if (matches) {
      store.dispatch(setViewport(Viewports.Laptop));
    } else {
      store.dispatch(setViewport(Viewports.Tablet));
    }
  };

  const handleDesktopViewportChange = ({ matches }) => {
    if (matches) {
      store.dispatch(setViewport(Viewports.Desktop));
    } else {
      store.dispatch(setViewport(Viewports.Laptop));
    }
  };

  if(tabletQuery?.addEventListener) {
    tabletQuery.addEventListener("change", handleTabletViewportChange);
    laptopQuery.addEventListener("change", handleLaptopViewportChange);
    desktopQuery.addEventListener("change", handleDesktopViewportChange);
  } else {
    tabletQuery.addListener(handleTabletViewportChange);
    laptopQuery.addListener(handleLaptopViewportChange);
    desktopQuery.addListener(handleDesktopViewportChange);
  }

  switch (true) {
    case desktopQuery.matches:
      store.dispatch(setViewport(Viewports.Desktop));
      break;
    case laptopQuery.matches:
      store.dispatch(setViewport(Viewports.Laptop));
      break;
    case tabletQuery.matches:
      store.dispatch(setViewport(Viewports.Tablet));
      break;
    default:
      store.dispatch(setViewport(Viewports.Mobile));
  }
};
